import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getScrollBarBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.3).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}

export const CusttomScrollBar = styled.div`
  /*&.flexbox-grow.fixedScrollbarHeight {
    height: 200px !important;
  }*/
  &.fixedScrollbar::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorByreference(props.design.questionText.color.value),
      )};
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        ),
      )};
  }
`;
export const SearchViewBlock = styled.div.attrs(() => ({}))``;

export const SearchResultBlock = styled.div.attrs(() => ({}))`
  .sr-only {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0 !important;
    border: 0 !important;
    height: 1px !important;
    width: 1px !important;
    overflow: hidden;
  }
  .showingResultsFor-layout-stripes {
    margin-top: 25px;
    margin-bottom: 25px;

    span {
      color: ${(props) =>
        wixService.getColorByreference(
          props.design.questionStripesText.color.value,
        )};
      color: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.color.name,
        )};
      ${(props) =>
        wixService.getStyleFontByReference(
          props.design.questionStripesText.font.value,
        )};
      font-size: 14px;
      /*line-height: 14px;*/
      font: ${(props) =>
        wixService.getFontValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.font.name,
        )};
      text-decoration: ${(props) =>
        wixService.getFontTextDecoration(
          props.styleParams,
          props.design.questionStripesText.font.name,
        )} !important;
      font-size: 14px;

      display: inline-block;
      &.label {
      }
      &.searchValue {
        font-weight: 700 !important;
        &.ltr {
          margin-left: 5px;
        }
        &.rtl {
          margin-right: 5px;
        }
      }
    }
  }
  .showingResultsFor-collapse-or-basic {
    margin-top: 25px;
    margin-bottom: 25px;
    span {
      color: ${(props) =>
        wixService.getColorByreference(props.design.questionText.color.value)};
      color: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        )};
      ${(props) =>
        wixService.getStyleFontByReference(
          props.design.questionText.font.value,
        )};
      font-size: 14px;
      /*line-height: 14px;*/
      font: ${(props) =>
        wixService.getFontValueByComponentName(
          props.styleParams,
          props.design.questionText.font.name,
        )};
      text-decoration: ${(props) =>
        wixService.getFontTextDecoration(
          props.styleParams,
          props.design.questionText.font.name,
        )} !important;
      font-size: 14px;

      display: inline-block;
      &.label {
      }
      &.searchValue {
        font-weight: 700 !important;
        &.ltr {
          margin-left: 5px;
        }
        &.rtl {
          margin-right: 5px;
        }
      }
    }
  }
`;

export const SearchNoResultBlock = styled.div.attrs(() => ({}))`
  &.layout-stripes {
    margin-top: 25px;
    margin-bottom: 25px;
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.questionStripesText.color.value,
      )};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionStripesText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(
        props.design.questionStripesText.font.value,
      )};
    font-size: 14px;
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.questionStripesText.font.name,
      )};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.questionStripesText.font.name,
      )} !important;
    font-size: 14px;
  }

  &.collapse-or-basic {
    margin-top: 25px;
    margin-bottom: 25px;
    color: ${(props) =>
      wixService.getColorByreference(props.design.questionText.color.value)};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(props.design.questionText.font.value)};
    font-size: 14px;
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.questionText.font.name,
      )};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.questionText.font.name,
      )} !important;
    font-size: 14px;
  }
`;
